import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Radio,
} from '@tencent/spaui';
import '../../../../../style/less/modules/state-manage.less';
import { RPCFactory } from '../../../../utils/RequestUtil';

const Item = ({ data }) => {
  const items = data.options || [{ label: '无' }];

  return (
    <div className="state-box__item">
      <div className="state-box__item-title">{data.label}</div>
      <div className="state-box__item-list">
        {
          items.map((item) => (
            <div key={item.label} className="state-box__child-item">
              {item.label}
            </div>
          ))
        }
      </div>
    </div>
  );
};

const StateBox = (props) => {
  const { current, value, label, onChange, tree = [] } = props;
  if (tree.length < 1) return null;
  return (
    <div className="state-box">
      <div className="state-box__title">
        <Radio value={value} checked={current === value} onChange={onChange}>
          <span>{label}</span>
        </Radio>
      </div>
      <div className="state-box__content">
        {tree.map((item) => (<Item key={item.label} data={item} />))}
      </div>
    </div>
  );
};

const Manage = () => {
  const dispatch = useDispatch();
  const state = useSelector(s => s.global);

  const handleIndustryChange = (e, val) => {
    const oldVal = state.industry;
    dispatch({
      type: 'INDUSTRY_SWITCH',
      payload: val,
    });
    RPCFactory.accountSettings.setIndustry({ leadsStatusSystemOption: val })
      .fail((ret, msg) => {
        alert(msg);
        dispatch({
          type: 'SET_INDUSTRY',
          payload: oldVal,
        });
      });
  };

  return (
    <div className="setting-state-manage card">
      <StateBox
        value={2}
        current={state.industry}
        label="使用行业化线索状态"
        onChange={handleIndustryChange}
        tree={state.industryStateTree}
      />
      <StateBox
        value={1}
        current={state.industry}
        label="使用线索通标准线索状态"
        onChange={handleIndustryChange}
        tree={state.commonStateTree}
      />
    </div>
  );
};

export default Manage;
